<template>
  <WorkBaseTabs
    v-bind="$props"
    content-class="w-tabs__content--table"
  />
</template>

<script>
import WorkBaseTabs from '@/components/base_components/tabs/WorkBaseTabs';

export default {
  name: 'WorkTabsTableContent',
  components: { WorkBaseTabs },
  props: {
    ...WorkBaseTabs.props,
    grow: { type: Boolean, default: true },
    value: { type: Number, default: 0 }
  },
};
</script>

<style lang='scss'>
.w-tabs__content--table {
  padding-top: 0 !important;
}
</style>
